


// Utility functions for intelligent phone number matching

/**
 * Normalize a phone number to a consistent format for comparison
 */
export function normalizePhoneNumber(phone: string): string {
    if (!phone) return '';
    
    // Don't normalize masked phone numbers - return as-is for comparison
    if (/\*{2,}/.test(phone)) {
        return phone;
    }
    
    // Remove all non-numeric characters except +
    let cleaned = phone.replace(/[^\d+]/g, '');
    
    // If it doesn't start with +, assume it's a US number
    if (!cleaned.startsWith('+')) {
        // If it's 10 digits, add +1
        if (cleaned.length === 10) {
            cleaned = '+1' + cleaned;
        }
        // If it's 11 digits and starts with 1, add +
        else if (cleaned.length === 11 && cleaned.startsWith('1')) {
            cleaned = '+' + cleaned;
        }
        // Otherwise add +1 (assuming US)
        else {
            cleaned = '+1' + cleaned;
        }
    }
    
    return cleaned;
}

/**
 * Check if two phone numbers are the same after normalization
 */
export function arePhoneNumbersEqual(phone1: string, phone2: string): boolean {
    return normalizePhoneNumber(phone1) === normalizePhoneNumber(phone2);
}

/**
 * Find matching phone number in a list
 */
export function findMatchingPhone(targetPhone: string, phoneList: string[]): string | null {
    const normalizedTarget = normalizePhoneNumber(targetPhone);
    
    for (const phone of phoneList) {
        if (normalizePhoneNumber(phone) === normalizedTarget) {
            return phone;
        }
    }
    
    return null;
}